import { useEffect, useMemo, useRef, useState } from 'react';

import Icon from '@klv/atoms/icon';
import useOutsideClick from '@klv/hooks/useOutsideClick';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/dropdownButton.module.scss';

import type { IDropdownButton } from './types';

export const DropdownButton = ({
  children,
  className = '',
  dropdownItems,
  dropdownName,
  ...props
}: IDropdownButton) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const handleKeyUp = useMemo(() => (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [handleKeyUp, open]);

  useOutsideClick(ref, () => {
    setOpen(false);
  });

  return (
    <div className={generateClassName([className, styles.dropdownButton, open && styles.open])} ref={ref} {...props}>
      <div className={styles.children}>{children}</div>
      <span>|</span>
      <button aria-controls={dropdownName} aria-label='open menu' className={styles.dropdownTrigger} onClick={() => setOpen((val) => !val)}>
        <Icon fillColor='currentColor' iconName='ChevronDown' size={0.6} />
      </button>
      <div className={styles.dropdown} id={dropdownName}>
        <ul>
          {dropdownItems.map((item, index) => (
            <li key={index}>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
